export function cloneDeep(value: any) {
  if (typeof window.structuredClone === 'function') {
    return structuredClone(value);
  } else {
    return JSON.parse(JSON.stringify(value));
  }
}
